import React from "react";
import { Link } from "react-router-dom";

import "./index.css";

import {
  getCoreRowModel,
  useReactTable,
  flexRender,
  getSortedRowModel,
} from "@tanstack/react-table";
function propertyLink(id) {
  let prop_link = "/dashboard/property/" + id;
  return prop_link;
}
function formatToCrowns(number) {
  if (number != null) {
    return number.toLocaleString().replace(/,/g, " ") + " kr";
  } else return "";
}

export default function Interest({ data }) {
  const defaultColumns = [
    {
      header: "Amortering",
      columns: [
        {
          accessorKey: "street",
          cell: (info) => <Link to={propertyLink(info.row.original.id)}>{info.getValue()}</Link>,
          header: () => <span>Adress</span>,
        },
        {
          accessorKey: "loanRatio",
          header: () => <span>Lånegrad</span>,
          cell: (info) => info.getValue() + "%",
        },
        {
          accessorKey: "amortizationRate",
          header: () => <span>Amortering</span>,
          cell: (info) => info.getValue() * 100 + "%",
        },
        {
          accessorKey: "incomeRatio",
          header: () => <span>lån/inkomst</span>,
          cell: (info) => info.getValue(),
        },
        {
          accessorKey: "extraAmortization",
          header: () => <span>Skärpt amorteringskrav</span>,
          cell: (info) => info.getValue() * 100 + "%",
        },
        {
          accessorKey: "totAmortizationRate",
          header: () => <span>Total amortering</span>,
          cell: (info) => info.getValue() * 100 + "%",
        },
        {
          accessorKey: "amortizationPerMonth",
          id: "deduction",
          header: () => <span>Amortering/mån</span>,
          cell: (info) => formatToCrowns(info.getValue()),
        },
      ],
    },
  ];
  // const [data, setData] = React.useState(() => [...defaultData]);
  // const [data] = React.useState(() => [...defaultData]);
  const [columns] = [defaultColumns]; // TODO here i am hacking! Usestate correctly?

  const [sorting, setSorting] = React.useState();

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <div className="p-2">
      <table>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th key={header.id} colSpan={header.colSpan}>
                    {header.isPlaceholder ? null : (
                      <div
                        {...{
                          className: header.column.getCanSort() ? "cursor-pointer select-none" : "",
                          onClick: header.column.getToggleSortingHandler(),
                        }}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {{
                          asc: " 🔼",
                          desc: " 🔽",
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
